import { PaymentProcessorEnum as a } from "./payment-processor.enum.mjs";
const s = (e, r) => {
  switch (e) {
    case a.Stripe:
      return "Stripe";
    case a.PaypalSoap:
    case a.PaypalRest:
      return "PayPal";
    case a.Dlocal:
      return "dLocal";
    case a.MercadoPagoBR:
    case a.MercadoPagoCO:
    case a.MercadoPagoMX:
    case a.MercadoPagoAR:
    case a.MercadoPagoCL:
      return "Mercado Pago";
    case a.Razorpay:
      return "Razorpay";
    case a.Flutterwave:
      return "Flutterwave";
    case a.Mollie:
      return "Mollie";
    case a.Gocardless:
      return "GoCardless";
    case a.XenditID:
    case a.XenditPH:
      return "Xendit";
    case a.PaystackGH:
    case a.PaystackKE:
    case a.PaystackNG:
    case a.PaystackZA:
    case a.PaystackEG:
    case a.PaystackCI:
      return "Paystack";
    case a.CashOnDelivery:
      return r("public_pages_purchase.payment.cash_on_delivery");
    case a.SecureAndPay:
      return "Secure and Pay";
  }
};
export {
  s as getPaymentProcessorTitle
};
